"use client";

import * as React from "react";
import { VirtualFittingRoom } from "./virtual-fitting-room";
import { useTryOn } from "./tryon-provider";
// import { cn } from "@/lib/utils";
import { Button } from "./ui/button";

interface TryOnButtonProps {
  dressId: string; // Changed 'key' to 'dressId'P
  dressImage: string;
  dressName: string;
  className: string;
  children: any;
  widgetClasses: string;
}

const TryOnButton: React.FC<TryOnButtonProps> = ({
  dressId,
  dressImage,
  dressName,
  className,
  children,
  widgetClasses,
}) => {
  const { apiKey, token } = useTryOn();
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <Button variant="default" onClick={handleOpen} className={className}>
        {children ? children : "Try On"}
      </Button>

      {isModalOpen && (
        <VirtualFittingRoom
          garmentId={dressId}
          garmentImage={dressImage}
          garmentName={dressName}
          garmentType="tops"
          onClose={() => setIsModalOpen(false)}
          apiKey={apiKey}
          token={token}
          widgetClasses={widgetClasses}
        />
      )}
    </>
  );
};

export default TryOnButton;
